import React from 'react';

// Order type filters
const orderTypeFilters = [
  { key: 'all', label: 'All', color: '#2B93FF' },
  { key: 'standard', label: 'Standard', color: '#2B93FF' },
  { key: 'return', label: 'Return', color: '#B37D6C' },
  { key: 'exchange', label: 'Exchange', color: '#FF9500' },
];

// Status filters
const statusFilters = [
  { key: 'pending', label: 'Pending', color: '#384553' },
  { key: 'failed', label: 'Failed', color: '#FF5245' },
  { key: 'actioned', label: 'Actioned', color: '#0BDA8E' },
];

export default function FilterTabs({
  activeTypeFilter,
  activeStatusFilter,
  onTypeFilterChange,
  onStatusFilterChange,
  counts,
}) {
  return (
    <div className="space-y-3">
      <div>
        <span className="text-xs font-medium text-locate2-light-gray uppercase tracking-wide mb-2 block">Order Type</span>
        <div className="flex flex-wrap gap-2">
          {orderTypeFilters.map(({ key, label, color }) => (
            <button
              key={key}
              onClick={() => onTypeFilterChange(key)}
              style={{
                backgroundColor: activeTypeFilter === key ? color : 'transparent',
                borderColor: color,
                color: activeTypeFilter === key ? 'white' : color,
              }}
              className="px-4 py-2 rounded-lg border-2 text-sm font-medium transition-all hover:opacity-80"
            >
              {label} ({counts[key] || 0})
            </button>
          ))}
        </div>
      </div>
      <div>
        <span className="text-xs font-medium text-locate2-light-gray uppercase tracking-wide mb-2 block">Status</span>
        <div className="flex flex-wrap gap-2">
          {statusFilters.map(({ key, label, color }) => (
            <button
              key={key}
              onClick={() => onStatusFilterChange(key)}
              style={{
                backgroundColor: activeStatusFilter === key ? color : 'transparent',
                borderColor: color,
                color: activeStatusFilter === key ? 'white' : color,
              }}
              className="px-4 py-2 rounded-lg border-2 text-sm font-medium transition-all hover:opacity-80"
            >
              {label} ({counts[key] || 0})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
